import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { TableCell, TableRow } from '@occc/ui-design-system';
import { baseRouteCreator } from '@occc-app/routes/CampaignComponents/utils';
import { offerEditRedirectRouteCreator } from '@occc-app/routes/OfferRedirect';

import { CampaignWithComponentTableRowActionsContainer } from './CampaignWithComponentTableRowActionsContainer';

import { CampaignComponentSanitized, CampaignWithCampaignComponentsSanitized } from '../types';

type CampaignWithComponentTableRow = {
  campaign: CampaignWithCampaignComponentsSanitized;
  isUserPermittedToEditCampaignComponent: boolean;
  isUserPermittedToDeleteCampaignComponent: boolean;
};

export const CampaignWithComponentTableRow = ({
  campaign,
  isUserPermittedToEditCampaignComponent,
  isUserPermittedToDeleteCampaignComponent,
}: CampaignWithComponentTableRow) => {
  const navigate = useNavigate();

  return (
    <>
      {campaign.campaignComponents?.map((campaignComponent: CampaignComponentSanitized) => {
        const { id, name, description, externalId, category, deleted } = campaignComponent;

        const shouldShowEditItem = isUserPermittedToEditCampaignComponent;
        const areActionsVisible =
          (shouldShowEditItem || isUserPermittedToDeleteCampaignComponent) && !deleted;

        const handleItemClick = () => {
          const detailsUrl = baseRouteCreator.details(campaign.uuid, id);
          navigate(detailsUrl);
        };
        const handleEdit = () => {
          navigate(offerEditRedirectRouteCreator.edit(id));
        };

        return (
          <TableRow key={id} onClick={handleItemClick}>
            <TableCell>
              <Box ml={3}>{name || ''}</Box>
            </TableCell>
            <TableCell>{description || ''}</TableCell>
            <TableCell>{category || ''}</TableCell>
            <TableCell>{externalId || ''}</TableCell>
            {areActionsVisible && (
              <TableCell padding='button' align='right'>
                <CampaignWithComponentTableRowActionsContainer
                  offerId={id}
                  name={name}
                  shouldShowEditItem={shouldShowEditItem}
                  shouldShowArchiveItem={isUserPermittedToDeleteCampaignComponent}
                  onEdit={handleEdit}
                />
              </TableCell>
            )}
          </TableRow>
        );
      })}
    </>
  );
};
